import type { Zero } from "@rocicorp/zero";
import { queries } from "../../../shared/queries";

export function preloadPersonalChats(z: Pick<Zero, "preload" | "userID">) {
  const url = new URL(window.location.href);
  if (url.pathname !== "/chats" || url.searchParams.has("userId")) return;

  // Retain completed preloads so cleanup cannot evict data while page queries subscribe.
  const preloads = [
    z.preload(queries.personalChatSummaries({ includeClosed: true }), {
      ttl: "5m",
    }),
    z.preload(queries.connectorsIndex(), { ttl: "5m" }),
  ];
  const personalChatId = url.searchParams.get("tab");
  if (personalChatId) {
    preloads.push(
      z.preload(
        queries.loadPersonalChat({ personalChatId, userId: z.userID! }),
        { ttl: "5m" }
      )
    );
  }
  for (const { complete, cleanup } of preloads) {
    void complete.then(cleanup, cleanup);
  }
}
